import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment-timezone';

import { TimeAgoBase } from './timeago';

@Pipe({
  name: 'rtTimeAgoAsync',
  pure: false,
  standalone: true,
})
export class TimeAgoAsyncPipe extends TimeAgoBase implements PipeTransform {
  public transform(
    value: moment.MomentInput,
    { omitSuffix }: { omitSuffix: boolean } = { omitSuffix: false },
  ): string {
    if (!value) {
      return '';
    }

    return this.getTime(value, omitSuffix);
  }
}
